export default {
  title: 'Ajustar pedido',
  product_info: {
    earn_points: 'Gana {{points}} puntos',
  },
};
